import { useState, useEffect } from 'react';

// Hook per gestire animazioni e transizioni
export const useAnimations = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Trigger animazione di entrata
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Animazione di entrata
  const animateIn = (callback) => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsVisible(true);
      setIsAnimating(false);
      if (callback) callback();
    }, 50);
  };

  // Animazione di uscita
  const animateOut = (callback) => {
    setIsAnimating(true);
    setIsVisible(false);
    setTimeout(() => {
      setIsAnimating(false);
      if (callback) callback();
    }, 300);
  };

  // Animazione di successo
  const animateSuccess = (callback) => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
      if (callback) callback();
    }, 600);
  };

  // Animazione di errore
  const animateError = (callback) => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
      if (callback) callback();
    }, 400);
  };

  // Classi CSS per animazioni
  const getAnimationClasses = (type = 'fadeIn') => {
    const baseClasses = 'transition-all duration-300 ease-in-out';
    
    if (!isVisible) {
      switch (type) {
        case 'fadeIn':
          return `${baseClasses} opacity-0 translate-y-4`;
        case 'slideInLeft':
          return `${baseClasses} opacity-0 -translate-x-4`;
        case 'slideInRight':
          return `${baseClasses} opacity-0 translate-x-4`;
        case 'scaleIn':
          return `${baseClasses} opacity-0 scale-95`;
        default:
          return `${baseClasses} opacity-0 translate-y-4`;
      }
    }

    switch (type) {
      case 'fadeIn':
        return `${baseClasses} opacity-100 translate-y-0`;
      case 'slideInLeft':
        return `${baseClasses} opacity-100 translate-x-0`;
      case 'slideInRight':
        return `${baseClasses} opacity-100 translate-x-0`;
      case 'scaleIn':
        return `${baseClasses} opacity-100 scale-100`;
      default:
        return `${baseClasses} opacity-100 translate-y-0`;
    }
  };

  // Classi per animazioni di interazione
  const getInteractionClasses = (isActive = false) => {
    const baseClasses = 'transition-all duration-200 ease-in-out';
    
    if (isActive) {
      return `${baseClasses} transform scale-105 shadow-lg`;
    }
    
    return `${baseClasses} hover:scale-105 hover:shadow-lg active:scale-95`;
  };

  // Classi per animazioni di caricamento
  const getLoadingClasses = () => {
    return 'animate-pulse';
  };

  // Classi per animazioni di successo
  const getSuccessClasses = () => {
    return 'animate-bounce';
  };

  // Classi per animazioni di errore
  const getErrorClasses = () => {
    return 'animate-shake';
  };

  return {
    isVisible,
    isAnimating,
    animateIn,
    animateOut,
    animateSuccess,
    animateError,
    getAnimationClasses,
    getInteractionClasses,
    getLoadingClasses,
    getSuccessClasses,
    getErrorClasses
  };
};
